'use strict';

(function () {
  const selectors = {
    component: '[data-product-tabs]',
    trigger: '[role="tab"]',
  };

  const keyActions = {
    ArrowLeft: -1,
    ArrowUp: -1,
    ArrowRight: 1,
    ArrowDown: 1,
    Home: 'start',
    End: 'end',
  };

  function initTabs(root) {
    const triggers = Array.from(root.querySelectorAll(selectors.trigger));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    if (!triggers.length || !panels.length) {
      return;
    }

    function activate(trigger) {
      const targetId = trigger.getAttribute('data-target');

      triggers.forEach((btn) => {
        const isActive = btn === trigger;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const isActive = panel.id === targetId;
        panel.classList.toggle('is-active', isActive);
      });
    }

    triggers.forEach((btn) => {
      btn.addEventListener('click', () => activate(btn));

      btn.addEventListener('keydown', (event) => {
        const action = keyActions[event.key];

        if (action === undefined) {
          return;
        }

        event.preventDefault();

        if (action === 'start') {
          activate(triggers[0]);
          triggers[0].focus();
          return;
        }

        if (action === 'end') {
          const last = triggers[triggers.length - 1];
          activate(last);
          last.focus();
          return;
        }

        const currentIndex = triggers.indexOf(btn);
        let nextIndex = currentIndex + action;

        if (nextIndex < 0) {
          nextIndex = triggers.length - 1;
        } else if (nextIndex >= triggers.length) {
          nextIndex = 0;
        }

        const next = triggers[nextIndex];
        activate(next);
        next.focus();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const components = document.querySelectorAll(selectors.component);

    components.forEach((component) => {
      initTabs(component);
    });
  });
})();
